<template  >
    <div class="cubeSpace d-flex flex-wrap justify-content-center align-items-center py-4 px-lg-3 px-4 px-lg-0 py-5 py-lg-0">
        <div class="col-12 col-lg-7 d-flex flex-wrap justify-content-center align-items-center align-content-center overflow-hidden">
            <div class="col-12 d-flex justify-content-center text-start align-items-center flex-wrap px-lg-4">
                <span class="font- label-1 d-flex flex-wrap">
                    <span class="font- fuente-nova label-2 mt-5 ps-3 w-100 fuentes-clamp4">Los días de promoción 2x1 en Sushiroll son muy populares y atraen a muchos 
clientes. 
<br><br>
Con Efisense Flow, optimizamos esta alta demanda creando una experiencia ordenada y agradable. Los clientes escanean el QR, entran a la fila virtual y disfrutan su tiempo mientras reciben notificaciones.
</span>
                </span>
                <div class="d-flex flex-wrap col-md-9 col-11 mt-5">
                    <div class="col-5">
                        <img :src="a10" class="img-fluid w-100">
                    </div>
                    <div class="col-7 d-flex flex-wrap justify-content-start align-items-center align-content-center">
                        <span class="font- fuente-nova2 label-3 mt-3 ps-3 w-100">Omar Lanestosa</span>
                        <span class="fuente-nova label-4 mt-1 ps-4 ms-1 w-100">Gerente de Operaciones Sushi Roll</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-5 d-flex flex-wrap justify-content-center align-items-center align-content-center overflow-hidden">

        </div>
    </div>  
</template>
<script>
export default {
    name: 'page11',
    emits: ['sendAction'],
    props: {
        action: {
            type: Object,
            default: () => {}
        }
    },
    watch: {
        action: {
            handler() {
                this.getAction()
            },
            deep: true
        }
    },
    data() {
        return {
            a1: require('@/assets/images/a1.png'),
            a10: require('@/assets/images/a42.webp'),
        }
    },
    methods: {
        makeAction() {
            switch (this.action.type) {
                case '?':
                    break
            }
        }
    },
}
</script>
<style lang="css" scoped>
    .cubeSpace {
        overflow: hidden;
        height: auto;
        width: 100vw;
        height: 100vh;
    }
    
    .label-1 {
        color: var(--color-2);
        font-size: 70px;
        line-height: 1.1;
        max-width: 820px;
        word-wrap: break-word;
    }
    .label-2 {
        color: var(--color-3);
        font-size: 23px;
        line-height: 1.1;
    }
    .label-3 {
        color: var(--color-3);
        font-size: 25px;
        line-height: 1.1;
    }
    .label-4 {
        color: var(--color-1);
        font-size: 22px;
        line-height: 1.1;
    }
    @media (max-width: 992px) and (min-width: 768px) {
        .label-1
        {
            font-size: 60px;
        }
        .label-2
        {
            font-size: 27px;
        }
        .label-3
        {
            font-size: 23px;
        }
        .label-4
        {
            font-size: 20px;
        }
    }
    @media (max-width: 767px) and (min-width: 0) {
        .label-1
        {
            font-size: 28px;
        }
        .label-2
        {
            font-size: 19px;
        }
        .label-3
        {
            font-size: 15px;
        }
        .label-4
        {
            font-size: 12px;
        }
    }
</style>